<template>
  <div>
    <label v-if="label" class="mr-1 text-size-14 text-mild">{{ label }}</label>
    <AppLabel variant="red">{{ appLabelText }}</AppLabel>
    <AppFormSelect
      :value="value"
      :text-field="textField"
      :value-field="valueField"
      :formOptions="options"
      :firstOption="firstOption"
      :disabled="disabled"
      :validation-state="validationState"
      @change="onChange"
      @mousedown="onMouseDown"
    />
    <FormInvalidFeedback :validation-state="validationState" :state="false" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppFormSelect from "@/components/atoms/input/AppFormSelect.vue";
import FormInvalidFeedback from "@/components/atoms/other/FormInvalidFeedback.vue";
import AppLabel from "@/components/atoms/input/AppLabel.vue";
import { ValidationStateType } from "@/types/Validation";

@Component({
  components: {
    AppFormSelect,
    FormInvalidFeedback,
    AppLabel
  }
})
export default class FormSelectGroup extends Vue {
  @Prop({
    validator: prop =>
      typeof prop === "string" || typeof prop === "number" || prop === null,
    required: true
  })
  value!: string | number | null;

  @Prop({
    type: Array,
    required: true,
    default: ""
  })
  options!: [];

  @Prop({
    type: String,
    default: "項目を選択して下さい"
  })
  firstOption!: string;

  @Prop({
    type: String,
    default: ""
  })
  label!: string;

  @Prop({
    type: String,
    default: "text"
  })
  textField!: string;

  @Prop({
    type: String,
    default: "value"
  })
  valueField!: string;

  @Prop({
    type: String,
    default: ""
  })
  appLabelText!: string;

  @Prop({
    type: String,
    default: "text"
  })
  type!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: Object,
    default: {}
  })
  validationState!: ValidationStateType;

  onChange(v: string) {
    this.$emit("input", v);
  }
  onMouseDown() {
    this.$emit("mousedown");
  }
}
</script>
<style lang="scss" scoped>
label {
  margin-bottom: 6px;
}
</style>
